import { getRenderingEngines } from '../RenderingEngine/getRenderingEngine';
import { viewportSupportsImageSlices, } from './viewportCapabilities';
export default function getViewportsWithImageURI(imageURI) {
    const renderingEngines = getRenderingEngines();
    const viewports = [];
    renderingEngines.forEach((renderingEngine) => {
        const viewportsForRenderingEngine = renderingEngine
            .getViewports()
            .filter(viewportSupportsImageSlices);
        viewportsForRenderingEngine.forEach((viewport) => {
            if (viewport.hasImageURI(imageURI)) {
                viewports.push(viewport);
            }
        });
    });
    return viewports;
}
